<template>
	<div>
		<van-nav-bar title="出入库" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiIndexCont">
			<router-link class="nav-item" :to="{path:'/rad/input'}" tag="div">
			 <van-button icon="scan" type="info" size="large">入库</van-button>
			</router-link>
			<router-link class="nav-item" :to="{path:'/rad/output'}" tag="div">
			  <van-button icon="scan" type="info" size="large">出库</van-button>
			</router-link>
			<router-link v-if="checkPermission('取消出入库')" class="nav-item" :to="{path:'/rad/cancelStatus'}" tag="div">
				<van-button icon="scan" type="info" size="large">取消出入库</van-button>
			</router-link>
			<router-link v-if="checkPermission('条码报废出库')" class="nav-item" :to="{path:'/rad/receiptOut'}" tag="div">
				<van-button icon="scan" type="info" size="large">领用/报废出库</van-button>
			</router-link>
			<router-link v-if="showPosition" class="nav-item" :to="{path:'/rad/stocktaking'}" tag="div">
				<van-button icon="scan" type="info" size="large">盘库</van-button>
			</router-link>
			<router-link v-if="showPosition" class="nav-item" :to="{path:'/rad/positionChange'}" tag="div">
				<van-button icon="scan" type="info" size="large">货位变更</van-button>
			</router-link>
		</div>
	</div>
</template>

<script>
	import {NavBar,Button} from 'vant';
	import configService from "../../service/configService";
	export default {
		data() {
			return {
				showPosition: true
			};
		},
		components: {
			[NavBar.name]: NavBar,
			[Button.name]: Button,
		},
		mounted: async function() {
			let resp = await configService.getConfigByName("扫码入库显示货位输入框");
			if (resp.data.Status === "1"){
				if (resp.data.Data && resp.data.Data.value === "否"){
					this.showPosition = false;
				}
			}
		},
		methods: {
			onClickLeft() {
				window.open('/colseWebView');
			},
		}
	}
</script>

<style scoped>
	.psiIndexCont{
	
		width:100%;
		margin:0 auto;
		margin-top:240px;
		margin-bottom:0.24rem;
		overflow: hidden;
	}
	.nav-item{
		margin-top: 2rem;
	}
	.nav-item span{
	  
	}
</style>
